import SquareStar from "@modules/common/icons/square-star"

import React from "react"
import { nanoid } from "nanoid"
const ReadonlyRating: React.FC<{ count?: number; size?: number | string }> = ({
    count = 0,
    size = 16,
}) => {
    const fractionalPart = Math.round((count % 1) * 10) / 10;
    const integerPart = Math.trunc(count)
    const arrayDefault = Array(5).fill(0)
    let fillValue = 100;
    if (fractionalPart < 0.8) fillValue = 50;
    if (fractionalPart < 0.3) fillValue = 0;
    const arrayStar = [
        ...Array(integerPart).fill(100),
        ...Array(fractionalPart > 0 ? 1 : 0).fill(fillValue),
    ]
    arrayDefault.splice(0, arrayStar.length, ...arrayStar)

    return (
        <div className="flex space-x-1">
            {arrayDefault.map((val, _index) => (
                <SquareStar key={`rating-${nanoid()}`} size={size} fill={val} rating={count} />
            ))}
        </div>
    )
}

export default ReadonlyRating
